<template>
  <v-data-table ref="dataTable" dense v-model="selected" :headers="computedHeaders" :items="computedRecords"
    :single-select="singleSelect" item-key="id" show-select :items-per-page="15" class="custom-select-table">
  </v-data-table>
</template>

<script>
export default {
  props: {
    /** Data to be displayed in the table */
    tableData: { type: Array, required: false, default: null }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      // 序号 分户被保险人 证件类型 证件号码 贫困标识 开户行 银行账号/一卡通号 分户被保险人地址 手机号码
      // 标的名称 标的详细名称
      // 地块编码 种植地点 数量单位 保险数量 组别 单位保额(元) 保险金额(元) 保险费率(%) 保险费(元) 备注
      headers: [
        { text: '序号', value: 'index' },
        { text: '被保险人', value: 'insured_name' },
        { text: '证件号码', value: 'id_number' },
        { text: '被保险人地址', value: 'insured_address' },
        { text: '标的名称', value: 'subject_name' },
        { text: '标的详细名称', value: 'subject_detail' },
        { text: '地块编码', value: 'land_code' },
        { text: '种植地点', value: 'planting_location' },
        {
          text: '保险数量(亩)',
          value: 'insurance_quantity'
        },
        { text: '单位保额(元)', value: 'unit_amount' },
        { text: '保险金额(元)', value: 'insurance_amount' },
        { text: '保险费率(%)', value: 'insurance_rate' },
        { text: '保险费(元)', value: 'insurance_premium' }
      ]
    }
  },
  computed: {
    computedHeaders () {
      return this.headers
    },
    computedRecords () {
      const records = this.tableData || this.records;
      return records?.map(record => ({
        ...record,
        insurance_quantity: record.insurance_quantity ? parseFloat(record.insurance_quantity).toFixed(1) : ''
      }));
    }
  },
  watch: {
    selected (val) {
      this.$emit('selection-changed', val)
    }
  }
}
</script>
<style scoped>
.custom-select-table {
  width: 100%;
}

::v-deep .v-data-table__wrapper {
  overflow-x: auto;
  overflow-y: auto; /* enable vertical scrolling */
  max-width: 100%;
  max-height: 75vh; /* use 75% of viewport height so the table adapts to screen size */
  -webkit-overflow-scrolling: touch; /* smooth scrolling on touch devices */
}

::v-deep .v-data-table>.v-data-table__wrapper>table {
  width: max-content;
  min-width: 100%;
}

::v-deep .v-data-table {
  width: 100%;
}

/* 自定义滚动条样式 */
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>
